import { render, staticRenderFns } from "./deviceComponent.vue?vue&type=template&id=126398d7"
import script from "./deviceComponent.vue?vue&type=script&lang=js"
export * from "./deviceComponent.vue?vue&type=script&lang=js"
import style0 from "./deviceComponent.vue?vue&type=style&index=0&id=126398d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports